import { z } from "zod";

export const categoryPermissionSchema = z.object({
  categoryId: z.number().int(),
  categoryName: z.string(),
  categoryDisplayName: z.string().nullable().optional(),
});

export const userSchema = z.object({
  id: z.number().int(),
  entraObjectId: z.string().nullable().optional(),
  email: z.email(),
  displayName: z.string().nullable().optional(),
  role: z.string().nullable().optional(),
  hasLoggedIn: z.boolean(),
  lastLoginAt: z.string().nullable().optional(),
  createdDate: z.string().nullable().optional(),
  loginCount: z.number().int(),
  isActive: z.boolean(),
  categoryPermissions: z.array(categoryPermissionSchema).default([]),
});

export const onboardUserRequestSchema = z.object({
  email: z.email(),
  categoryIds: z.array(z.number().int()).optional().default([]),
});

export const setPermissionsRequestSchema = z.object({
  categoryIds: z.array(z.number().int()),
});
